import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_616_26367)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M19.4 9.998c0-5.192-4.207-9.4-9.4-9.4a9.398 9.398 0 00-9.4 9.4c0 4.692 3.438 8.58 7.931 9.287v-6.57H6.143V9.998h2.388v-2.07c0-2.356 1.403-3.658 3.55-3.658 1.03 0 2.105.184 2.105.184v2.312h-1.185c-1.168 0-1.532.725-1.532 1.468v1.764h2.607l-.417 2.718h-2.19v6.569c4.494-.706 7.931-4.595 7.931-9.287z",
    fill: "#3C5A99"
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_616_26367"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0H20V20H0z"
  }))));
}
export default SvgComponent;